import React from 'react';

function MenuItem({ name, icon, onClick }) {
  return (
    <div className="menu-item cursor" onClick={onClick}>
      {icon && <img style={{ height: '15px' }} src={icon} alt={name} />}
      {name}
    </div>
  );
}

export default MenuItem;